import AlternativesJSON from "./alternatives.json";

const normalizeString = (valueString: string) => {
  if (valueString) {
    valueString = valueString.replace(/ñ/gi, 'n');
    valueString = valueString.toLowerCase();
    valueString = valueString.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    return valueString;
  }
  return "";
}

const getPlanSelected = (plans: Array<any>) => {
  for (let i = 0; i < plans.length; i++) {
    if (plans[i].id_question === 1) {
      return plans[i].alternative_text
    }
  }
}

const getActivitiesToDo = (fullAnswers: Array<any>) => {
  for (let i = 0; i < fullAnswers.length; i++) {
    if (fullAnswers[i].id_question === 5 || fullAnswers[i].id_question === 6) {
      if (typeof fullAnswers[i].alternative_text === 'string') {
        return [fullAnswers[i].alternative_text]
      }
      return fullAnswers[i].alternatives
    }
  }
}

const normalizeAlternatives = (alternatives: Array<any>) => {
  let alternativesNormalized = Array<any>()
  if (alternatives) {
    for (let i = 0; i < alternatives.length; i++) {
      // console.log("before normalize", alternatives[i].alternative_text)
      if (alternatives[i] === AlternativesJSON.basico) alternativesNormalized.push('basico')
      if (alternatives[i] === AlternativesJSON.medio) alternativesNormalized.push('medio')
      if (alternatives[i] === AlternativesJSON.alto) alternativesNormalized.push('alto')
    }
    // console.log("normalizeAlternatives", alternativesNormalized)
    return alternativesNormalized.join("-")
  }
  // console.log("normalizeAlternatives", alternativesNormalized)
  return ""
}

const setActivitiesToDoAlternative = (alternative: string) => {
  if (alternative === AlternativesJSON.basico) return 'basico'
  if (alternative === AlternativesJSON.medio) return 'medio'
  if (alternative === AlternativesJSON.alto) return 'alto'
}

const getConectedDevicesAlternatives = (alternatives: Array<any>) => {
  let result = []
  for (let i = 0; i < alternatives.length; i++) {
    if (alternatives[i].id_question === 2) {
      result.push(normalizeString(alternatives[i].alternative_text))
    }
    if (alternatives[i].id_question === 3) {
      result.push(normalizeString(alternatives[i].alternative_text))
    }
    if (alternatives[i].id_question === 4) {
      result.push(normalizeString(alternatives[i].alternative_text))
    }
  }
  return result.join("-")
}

const formatConnectedDevices = (connectedDevices: string) => {
  // console.log("formatConnectedDevices1", connectedDevices);
  let connectedDevicesCopy: string = connectedDevices;
  connectedDevicesCopy = connectedDevicesCopy.replace(/menos de 8 dispositivos/g, "menos de 8");
  connectedDevicesCopy = connectedDevicesCopy.replace(/entre 8 y 16 dispositivos/g, "entre 8 y 16");
  connectedDevicesCopy = connectedDevicesCopy.replace(/mas de 16 dispositivos/g, "mas de 16");
  // console.log("formatConnectedDevices2", connectedDevicesCopy);
  return connectedDevicesCopy;
}

const eventLabelConnectedDevices = (connectedDevices: string) => {
  console.log("eventLabelConnectedDevices", connectedDevices);
  if (connectedDevices === "Menos de 8 dispositivos") return "menos de 8"
  if (connectedDevices === "Entre 8 y 16 dispositivos") return "entre 8 y 16"
  if (connectedDevices === "Más de 16 dispositivos") return "mas de 16"
}


export {
  getPlanSelected,
  normalizeString,
  getActivitiesToDo,
  normalizeAlternatives,
  getConectedDevicesAlternatives,
  setActivitiesToDoAlternative,
  formatConnectedDevices,
  eventLabelConnectedDevices
}